import React, { useState } from 'react'
import Account from './Account'
import Transactions from './Transactions'


const InnerPage = (props) => {


  return (
    <div>
        { props.accountPage && <Account  />}

        { props.transactionPage && <Transactions />}
    </div>
  )
}

export default InnerPage